import {useQuery} from "@tanstack/react-query";
import {ApiConfig} from "@/config/api.config";
import {DashboardOrdersResponseDto} from '@/features/dashboard/types/dashboard-dto';
import {UrlHelper} from "@/utils/UrlHelper.ts";
import {DateTimeHelper} from "@/utils/dateTimeHelper.ts";
import { useDashboardFilter } from '@/features/dashboard/hooks/useDashboardFilter';
import {useAxiosAuth} from "@/hooks/useAxiosAuth.ts";

export const useDashboardRecentOrdersApi = () => {
    const axiosInstance = useAxiosAuth();
    const { filter } = useDashboardFilter();
    const { startDate, endDate, apartmentId } = filter;

    const apartmentIds = apartmentId?.map((apartment) => apartment.id);

    const {
        data: recentOrdersData,
        isLoading: isLoadingRecentOrdersData,
        isError: isErrorRecentOrdersData
    } = useQuery({
        queryKey: [
            ApiConfig.queries.features.dashboard.queryKeys.recentOrders,
            startDate, endDate, apartmentId
        ],
        queryFn: async () => {
            const url = UrlHelper.buildUrlWithQueryParams(ApiConfig.queries.features.dashboard.endpoints.recentOrders, {
                startDate: DateTimeHelper.getDateOnly(startDate),
                endDate: DateTimeHelper.getDateOnly(endDate),
                apartmentId: apartmentIds
            });
            const response = await axiosInstance.get<DashboardOrdersResponseDto>(url);
            return response.data;
        },
    });

    return {
        recentOrdersData,
        isLoadingRecentOrdersData,
        isErrorRecentOrdersData,
    }
};